export const basketSceneLayout = {
  camera: { x: 0, y: 4.5, z: 9.5, lookAtX: 0, lookAtY: 3.8, lookAtZ: -9.25, fov: 48 },
  hoop: { x: 0, y: 4.5, z: -9.25 },
  backboard: { x: 0, y: 5.3, z: -10.2, width: 3.6, height: 2.4 },
  ballRest: { x: 0, y: 1.8, z: -1, radius: 0.65 },
  flightApexY: 8,
} as const;

export function basketShotStartX(choiceIndex: number, choiceCount: number) {
  if (choiceCount <= 1) return 0;
  const safeCount = Math.max(2, Math.min(5, choiceCount));
  const safeIndex = Math.max(0, Math.min(safeCount - 1, choiceIndex));
  return -2.2 + (4.4 * safeIndex) / (safeCount - 1);
}

export function basketMissOffset(choiceIndex: number) {
  const variants = [
    { x: -0.82, y: 0.12, z: 0.04 },
    { x: 0.74, y: 0.18, z: -0.08 },
    { x: -0.28, y: 0.92, z: -0.7 },
    { x: 0.3, y: -0.2, z: 0.72 },
    { x: 0.92, y: 0.45, z: 0.2 },
  ] as const;
  return variants[Math.abs(choiceIndex) % variants.length];
}

export type BasketShotImpact = 'swish' | 'rim' | 'backboard';

export function basketShotImpact(correct: boolean, choiceIndex: number): BasketShotImpact {
  if (correct) return 'swish';
  return Math.abs(choiceIndex) % 5 === 2 ? 'backboard' : 'rim';
}
